module.exports = __webpack_public_path__ + "static/media/pic36.70385598.jpg";